import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../redux/storeConfig/store'
import { checkFeatureFlag, selectFeatureFlagEnabled } from '../redux/storeConfig/slices/slice.featureFlags'
import ContentLoader from './global/loaders/ContentLoader'

interface FeatureFlaggedRouteProps {
  flagKey: string
  enabledComponent: React.ComponentType<Record<string, unknown>>
  fallbackComponent: React.ComponentType<Record<string, unknown>>
  componentProps?: Record<string, unknown>
}

const FeatureFlaggedRoute = ({
  flagKey,
  enabledComponent: EnabledComponent,
  fallbackComponent: FallbackComponent,
  componentProps = {}
}: FeatureFlaggedRouteProps) => {
  const dispatch = useAppDispatch()
  const isEnabled = useAppSelector(state => selectFeatureFlagEnabled(state, flagKey))
  const isChecked = useAppSelector(state => state.featureFlags?.flags?.[flagKey] !== undefined)
  const status = useAppSelector(state => state.featureFlags?.status)

  useEffect(() => {
    dispatch(checkFeatureFlag({ key: flagKey }))
  }, [flagKey, dispatch])

  if (!isChecked && status === 'loading') {
    return <ContentLoader />
  }

  if (isEnabled) {
    return <EnabledComponent {...componentProps} />
  }

  return <FallbackComponent {...componentProps} />
}

export default FeatureFlaggedRoute
